import { HttpService, QueryHandler, TaggedUrl, Tags } from '@skylab-shared/core';
import { Mutable } from '@skylab-shared/types';
import { PagedCollectionQuery, PagedCollectionQueryResult } from '../../common/query/paged-collection-query';

export interface ExpensePagedCollectionItem {
    readonly id: number;
    readonly name: string;
}

export class ExpensePagedCollectionQuery extends PagedCollectionQuery<ExpensePagedCollectionItem> { }

export class ExpensePagedCollectionQueryHandlerBase implements QueryHandler<ExpensePagedCollectionQuery, PagedCollectionQueryResult<ExpensePagedCollectionItem>> {

    public constructor(private readonly http: HttpService) { }

    public async handleAsync(query: ExpensePagedCollectionQuery): Promise<PagedCollectionQueryResult<ExpensePagedCollectionItem>> {
        const url = TaggedUrl.join('purchase/expenseNames', [Tags.Api]);
        const { data } = await this.http.get<Mutable<PagedCollectionQueryResult<ExpensePagedCollectionItem>>>(url, { params: { ...query.params } });
        const items = data.items.map(i => {
            return {
                id: i.id,
                name: i.name,
            };
        });
        return {
            totalItemsCount: data.totalItemsCount,
            items: items
        };
    }
}
